export default [
  {
    language: "af",
    name: "Tiếng Nam Phi",
    emoji: "🇿🇦",
  },
  {
    language: "ak",
    name: "Tiếng Akan",
    emoji: "🇬🇭",
  },
  {
    language: "sq",
    name: "Tiếng Albania",
    emoji: "🇦🇱",
  },
  {
    language: "am",
    name: "Tiếng Amharic",
    emoji: "🇪🇹",
  },
  {
    language: "ar",
    name: "Tiếng Ả Rập",
    emoji: "🇸🇦",
  },
  {
    language: "hy",
    name: "Tiếng Armenia",
    emoji: "🇦🇲",
  },
  {
    language: "as",
    name: "Tiếng Assam",
    emoji: "🇮🇳",
  },
  {
    language: "ay",
    name: "Tiếng Aymara",
    emoji: "🇧🇴",
  },
  {
    language: "az",
    name: "Tiếng Azerbaijan",
    emoji: "🇦🇿",
  },
  {
    language: "bm",
    name: "Tiếng Bambara",
    emoji: "🇲🇱",
  },
  {
    language: "eu",
    name: "Tiếng Basque",
    emoji: "🇪🇸",
  },
  {
    language: "be",
    name: "Tiếng Belarus",
    emoji: "🇧🇾",
  },
  {
    language: "bn",
    name: "Tiếng Bengali",
    emoji: "🇧🇩",
  },
  {
    language: "bho",
    name: "Tiếng Bhojpuri",
    emoji: "🇮🇳",
  },
  {
    language: "bs",
    name: "Tiếng Bosnia",
    emoji: "🇧🇦",
  },
  {
    language: "bg",
    name: "Tiếng Bulgaria",
    emoji: "🇧🇬",
  },
  {
    language: "ca",
    name: "Tiếng Catalan",
    emoji: "🇪🇸",
  },
  {
    language: "ceb",
    name: "Tiếng Cebuano",
    emoji: "🇵🇭",
  },
  {
    language: "ny",
    name: "Tiếng Chichewa",
    emoji: "🇲🇼",
  },
  {
    language: "zh",
    name: "Tiếng Trung (Giản thể)",
    emoji: "🇨🇳",
  },
  {
    language: "zh-tw",
    name: "Tiếng Trung (Phồn thể)",
    emoji: "🇹🇼",
  },
  {
    language: "co",
    name: "Tiếng Corse",
    emoji: "🇫🇷",
  },
  {
    language: "hr",
    name: "Tiếng Croatia",
    emoji: "🇭🇷",
  },
  {
    language: "cs",
    name: "Tiếng Séc",
    emoji: "🇨🇿",
  },
  {
    language: "da",
    name: "Tiếng Đan Mạch",
    emoji: "🇩🇰",
  },
  {
    language: "dv",
    name: "Tiếng Divehi",
    emoji: "🇲🇻",
  },
  {
    language: "doi",
    name: "Tiếng Dogri",
    emoji: "🇮🇳",
  },
  {
    language: "nl",
    name: "Tiếng Hà Lan",
    emoji: "🇳🇱",
  },
  {
    language: "en",
    name: "Tiếng Anh",
    emoji: "🇬🇧",
  },
  {
    language: "eo",
    name: "Tiếng Esperanto",
    emoji: "🌍",
  },
  {
    language: "et",
    name: "Tiếng Estonia",
    emoji: "🇪🇪",
  },
  {
    language: "ee",
    name: "Tiếng Ewe",
    emoji: "🇹🇬",
  },
  {
    language: "tl",
    name: "Tiếng Filipino",
    emoji: "🇵🇭",
  },
  {
    language: "fi",
    name: "Tiếng Phần Lan",
    emoji: "🇫🇮",
  },
  {
    language: "fr",
    name: "Tiếng Pháp",
    emoji: "🇫🇷",
  },
  {
    language: "fy",
    name: "Tiếng Frisia",
    emoji: "🇳🇱",
  },
  {
    language: "gl",
    name: "Tiếng Galicia",
    emoji: "🇪🇸",
  },
  {
    language: "lg",
    name: "Tiếng Ganda",
    emoji: "🇺🇬",
  },
  {
    language: "ka",
    name: "Tiếng Gruzia",
    emoji: "🇬🇪",
  },
  {
    language: "de",
    name: "Tiếng Đức",
    emoji: "🇩🇪",
  },
  {
    language: "gom",
    name: "Tiếng Konkani Goan",
    emoji: "🇮🇳",
  },
  {
    language: "el",
    name: "Tiếng Hy Lạp",
    emoji: "🇬🇷",
  },
  {
    language: "gn",
    name: "Tiếng Guarani",
    emoji: "🇵🇾",
  },
  {
    language: "gu",
    name: "Tiếng Gujarati",
    emoji: "🇮🇳",
  },
  {
    language: "ht",
    name: "Tiếng Creole Haiti",
    emoji: "🇭🇹",
  },
  {
    language: "ha",
    name: "Tiếng Hausa",
    emoji: "🇳🇬",
  },
  {
    language: "haw",
    name: "Tiếng Hawaii",
    emoji: "🇺🇸",
  },
  {
    language: "iw",
    name: "Tiếng Hebrew",
    emoji: "🇮🇱",
  },
  {
    language: "hi",
    name: "Tiếng Hindi",
    emoji: "🇮🇳",
  },
  {
    language: "hmn",
    name: "Tiếng Hmong",
    emoji: "🇨🇳",
  },
  {
    language: "hu",
    name: "Tiếng Hungary",
    emoji: "🇭🇺",
  },
  {
    language: "is",
    name: "Tiếng Iceland",
    emoji: "🇮🇸",
  },
  {
    language: "ig",
    name: "Tiếng Igbo",
    emoji: "🇳🇬",
  },
  {
    language: "ilo",
    name: "Tiếng Iloko",
    emoji: "🇵🇭",
  },
  {
    language: "id",
    name: "Tiếng Indonesia",
    emoji: "🇮🇩",
  },
  {
    language: "ga",
    name: "Tiếng Ireland",
    emoji: "🇮🇪",
  },
  {
    language: "it",
    name: "Tiếng Ý",
    emoji: "🇮🇹",
  },
  {
    language: "ja",
    name: "Tiếng Nhật",
    emoji: "🇯🇵",
  },
  {
    language: "jw",
    name: "Tiếng Java",
    emoji: "🇮🇩",
  },
  {
    language: "kn",
    name: "Tiếng Kannada",
    emoji: "🇮🇳",
  },
  {
    language: "kk",
    name: "Tiếng Kazakh",
    emoji: "🇰🇿",
  },
  {
    language: "km",
    name: "Tiếng Khmer",
    emoji: "🇰🇭",
  },
  {
    language: "rw",
    name: "Tiếng Kinyarwanda",
    emoji: "🇷🇼",
  },
  {
    language: "ko",
    name: "Tiếng Hàn Quốc",
    emoji: "🇰🇷",
  },
  {
    language: "kri",
    name: "Tiếng Krio",
    emoji: "🇸🇱",
  },
  {
    language: "ku",
    name: "Tiếng Kurd (Kurmanji)",
    emoji: "🇹🇷",
  },
  {
    language: "ckb",
    name: "Tiếng Kurd (Sorani)",
    emoji: "🇮🇶",
  },
  {
    language: "ky",
    name: "Tiếng Kyrgyz",
    emoji: "🇰🇬",
  },
  {
    language: "lo",
    name: "Tiếng Lào",
    emoji: "🇱🇦",
  },
  {
    language: "la",
    name: "Tiếng Latinh",
    emoji: "🇻🇦",
  },
  {
    language: "lv",
    name: "Tiếng Latvia",
    emoji: "🇱🇻",
  },
  {
    language: "ln",
    name: "Tiếng Lingala",
    emoji: "🇨🇩",
  },
  {
    language: "lt",
    name: "Tiếng Lithuania",
    emoji: "🇱🇹",
  },
  {
    language: "lb",
    name: "Tiếng Luxembourg",
    emoji: "🇱🇺",
  },
  {
    language: "mk",
    name: "Tiếng Macedonia",
    emoji: "🇲🇰",
  },
  {
    language: "mai",
    name: "Tiếng Maithili",
    emoji: "🇮🇳",
  },
  {
    language: "mg",
    name: "Tiếng Malagasy",
    emoji: "🇲🇬",
  },
  {
    language: "ms",
    name: "Tiếng Mã Lai",
    emoji: "🇲🇾",
  },
  {
    language: "ml",
    name: "Tiếng Malayalam",
    emoji: "🇮🇳",
  },
  {
    language: "mt",
    name: "Tiếng Malta",
    emoji: "🇲🇹",
  },
  {
    language: "mni-mtei",
    name: "Tiếng Manipuri (Meitei Mayek)",
    emoji: "🇮🇳",
  },
  {
    language: "mi",
    name: "Tiếng Maori",
    emoji: "🇳🇿",
  },
  {
    language: "mr",
    name: "Tiếng Marathi",
    emoji: "🇮🇳",
  },
  {
    language: "lus",
    name: "Tiếng Mizo",
    emoji: "🇮🇳",
  },
  {
    language: "mn",
    name: "Tiếng Mông Cổ",
    emoji: "🇲🇳",
  },
  {
    language: "my",
    name: "Tiếng Myanmar (Miến Điện)",
    emoji: "🇲🇲",
  },
  {
    language: "ne",
    name: "Tiếng Nepal",
    emoji: "🇳🇵",
  },
  {
    language: "nso",
    name: "Tiếng Northern Sotho",
    emoji: "🇿🇦",
  },
  {
    language: "no",
    name: "Tiếng Na Uy",
    emoji: "🇳🇴",
  },
  {
    language: "or",
    name: "Tiếng Oriya (Odia)",
    emoji: "🇮🇳",
  },
  {
    language: "om",
    name: "Tiếng Oromo",
    emoji: "🇪🇹",
  },
  {
    language: "ps",
    name: "Tiếng Pashto",
    emoji: "🇦🇫",
  },
  {
    language: "fa",
    name: "Tiếng Ba Tư",
    emoji: "🇮🇷",
  },
  {
    language: "pl",
    name: "Tiếng Ba Lan",
    emoji: "🇵🇱",
  },
  {
    language: "pt",
    name: "Tiếng Bồ Đào Nha (Bồ Đào Nha)",
    emoji: "🇵🇹",
  },
  {
    language: "pa",
    name: "Tiếng Punjab",
    emoji: "🇮🇳",
  },
  {
    language: "qu",
    name: "Tiếng Quechua",
    emoji: "🇵🇪",
  },
  {
    language: "ro",
    name: "Tiếng Romania",
    emoji: "🇷🇴",
  },
  {
    language: "ru",
    name: "Tiếng Nga",
    emoji: "🇷🇺",
  },
  {
    language: "sm",
    name: "Tiếng Samoa",
    emoji: "🇼🇸",
  },
  {
    language: "sa",
    name: "Tiếng Phạn",
    emoji: "🇮🇳",
  },
  {
    language: "gd",
    name: "Tiếng Scots Gaelic",
    emoji: "🏴",
  },
  {
    language: "sr",
    name: "Tiếng Serbia",
    emoji: "🇷🇸",
  },
  {
    language: "st",
    name: "Tiếng Sesotho",
    emoji: "🇱🇸",
  },
  {
    language: "sn",
    name: "Tiếng Shona",
    emoji: "🇿🇼",
  },
  {
    language: "sd",
    name: "Tiếng Sindhi",
    emoji: "🇵🇰",
  },
  {
    language: "si",
    name: "Tiếng Sinhala",
    emoji: "🇱🇰",
  },
  {
    language: "sk",
    name: "Tiếng Slovak",
    emoji: "🇸🇰",
  },
  {
    language: "sl",
    name: "Tiếng Slovenia",
    emoji: "🇸🇮",
  },
  {
    language: "so",
    name: "Tiếng Somali",
    emoji: "🇸🇴",
  },
  {
    language: "es",
    name: "Tiếng Tây Ban Nha",
    emoji: "🇪🇸",
  },
  {
    language: "su",
    name: "Tiếng Sundan",
    emoji: "🇮🇩",
  },
  {
    language: "sw",
    name: "Tiếng Swahili",
    emoji: "🇰🇪",
  },
  {
    language: "sv",
    name: "Tiếng Thụy Điển",
    emoji: "🇸🇪",
  },
  {
    language: "tg",
    name: "Tiếng Tajik",
    emoji: "🇹🇯",
  },
  {
    language: "ta",
    name: "Tiếng Tamil",
    emoji: "🇮🇳",
  },
  {
    language: "tt",
    name: "Tiếng Tatar",
    emoji: "🇷🇺",
  },
  {
    language: "te",
    name: "Tiếng Telugu",
    emoji: "🇮🇳",
  },
  {
    language: "th",
    name: "Tiếng Thái",
    emoji: "🇹🇭",
  },
  {
    language: "ti",
    name: "Tiếng Tigrinya",
    emoji: "🇪🇷",
  },
  {
    language: "ts",
    name: "Tiếng Tsonga",
    emoji: "🇿🇦",
  },
  {
    language: "tr",
    name: "Tiếng Thổ Nhĩ Kỳ",
    emoji: "🇹🇷",
  },
  {
    language: "tk",
    name: "Tiếng Turkmen",
    emoji: "🇹🇲",
  },
  {
    language: "uk",
    name: "Tiếng Ukraina",
    emoji: "🇺🇦",
  },
  {
    language: "ur",
    name: "Tiếng Urdu",
    emoji: "🇵🇰",
  },
  {
    language: "ug",
    name: "Tiếng Uyghur",
    emoji: "🇨🇳",
  },
  {
    language: "uz",
    name: "Tiếng Uzbek",
    emoji: "🇺🇿",
  },
  {
    language: "vi",
    name: "Tiếng Việt",
    emoji: "🇻🇳",
  },
  {
    language: "cy",
    name: "Tiếng Wales",
    emoji: "🏴",
  },
  {
    language: "xh",
    name: "Tiếng Xhosa",
    emoji: "🇿🇦",
  },
  {
    language: "yi",
    name: "Tiếng Yiddish",
    emoji: "🇮🇱",
  },
  {
    language: "yo",
    name: "Tiếng Yoruba",
    emoji: "🇳🇬",
  },
  {
    language: "zu",
    name: "Tiếng Zulu",
    emoji: "🇿🇦",
  },
  {
    language: "he",
    name: "Tiếng Do Thái",
    emoji: "🇮🇱",
  },
  {
    language: "jv",
    name: "Tiếng Java",
    emoji: "🇮🇩",
  },
  {
    language: "zh-cn",
    name: "Tiếng Trung (Giản thể)",
    emoji: "🇨🇳",
  },
];
